const ARTICLE_ROOT = 'https://www.guidebg.com/in-the-measures-of-mankind/'

const DEDICATED_ARTICLE_PAGES = {
  length: '3/',
  mass: '4/',
  volume: '5/',
  time: '6/',
}

export function getArticleUrl(categoryId) {
  return `${ARTICLE_ROOT}${DEDICATED_ARTICLE_PAGES[categoryId] ?? '2/'}`
}

export function hasDedicatedArticlePage(categoryId) {
  return categoryId in DEDICATED_ARTICLE_PAGES
}
